function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "18.-settings",
  transform: "translate(-320.000000, -36.000000)",
  stroke: "#4199BA",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(28.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-6",
  transform: "translate(281.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(12.500000, 10.222222)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.08333333,-1.30555556 L5.91666667,12.8611111",
  id: "Line-2-Copy-3",
  transform: "translate(5.500000, 5.777778) rotate(-225.000000) translate(-5.500000, -5.777778) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.91666667,-1.30555556 L5.08333333,12.8611111",
  id: "Line-2-Copy-3",
  transform: "translate(5.500000, 5.777778) rotate(-135.000000) translate(-5.500000, -5.777778) "
}))))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.19a19998.svg";
export { ForwardRef as ReactComponent };